// Copyright 2026, Imprivata, Inc.  All rights reserved.

import CheckedImg from '../../assets/icons/circle-checked.svg?react';
import UnCheckedImg from '../../assets/icons/circle.svg?react';

import './ValidationRules.less';

export interface ValidationRule {
  id: string;
  label: string | ((value: string) => string);
  validate: (value: string) => boolean;
}
interface ValidationRulesProps {
  value?: string;
  rules: ValidationRule[];
}

const ValidationRules = ({ value = '', rules }: ValidationRulesProps) => {
  return (
    <div className="validation-rules">
      {rules.map(rule => {
        const isValid = rule.validate(value);

        return (
          <div
            key={rule.id}
            className={`validation-rules-item ${
              isValid ? 'validation-rules-item--valid' : 'validation-rules-item--invalid'
            }`}
          >
            {isValid ? (
              <CheckedImg className="validation-rules-icon" />
            ) : (
              <UnCheckedImg className="validation-rules-icon" />
            )}

            <span>{typeof rule.label === 'function' ? rule.label(value) : rule.label}</span>
          </div>
        );
      })}
    </div>
  );
};

export default ValidationRules;
